import { ChangeEvent, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getTemplateDetail, getTemplatesRulesGroup } from 'services/templateService';
import { createOrder, getOrdersCode } from 'services/ordersService';
import arrowIcon from '../../../assets/arrowNext.png';
import Breadcrumb from 'components/atoms/Breadcrumb/Breadcrumb';
import AppSelect from 'components/atoms/AppSelect/AppSelect';
import { TextArea } from 'components/atoms/TextArea/TextArea';
import { AccordionRules } from 'components/molecules/AccordionRule/AccordionRule';
import AppButton from 'components/atoms/AppButton/AppButton';
import Message from 'components/atoms/Message/Message';
import PreviewEmpty from '../../../orders/presentation/components/molecules/PreviewEmpty';

export const CreateOrders = () => {
    const [code, setCode] = useState<null | string>(null)
    const [templates, setTemplates] = useState([])
    const [textDescription, setTextDescription] = useState('')
    const [error, setError] = useState<null | string>(null)
    const [confirmMessage, setConfirmMessage] = useState<null | string>(null)
  const [templateSelected, setTemplateSelected] = useState('');
    const [rules, setRules] = useState([])
    const navigate = useNavigate()

    const breadcrumbNavigate = [
        {
            label: 'Ordenes',
            path: '/ordenes',
        },
        {
            label: 'Cargar orden',
            path: '/ordenes',
        },
    ]

    const handleSelectTemplate = (e: ChangeEvent) => {
        const selectElement = e.target as HTMLSelectElement
      setTemplateSelected(selectElement.value);
    }

    const sendData = async () => {
        try {
            await createOrder({
                description: textDescription,
                template_id: Number(templateSelected),
              created_after_than: '',
                created_before_than: '',
            })
            setConfirmMessage(`Orden creada con éxito.`)
            setTimeout(() => {
                setConfirmMessage(null)
                navigate('/orders')
            }, 5000)
        } catch (error) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            setError((error as any).message)
            setTimeout(() => {
                setError(null)
            }, 5000)
        }
    }

    useEffect(() => {
        const fetchPackages = async () => {
            const { data } = await getTemplatesRulesGroup()
            const response = await getOrdersCode()
            setCode(response.data.code)
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const formatData = data.map((item: any) => {
                return {
                    value: item.id,
                    label: item.name,
                }
            })
            setTemplates(formatData)
        }
        fetchPackages()
    }, [])

    useEffect(() => {
      if (templateSelected !== '') {
            const fetchTemplateDetail = async () => {
              const response = await getTemplateDetail(Number(templateSelected));
                setRules(response.groups)
            }
            fetchTemplateDetail()
        }
    }, [templateSelected])
    return (
        <div>
            <Breadcrumb
                items={breadcrumbNavigate}
                title="Cargar orden con criterios"
                separator={<img src={arrowIcon} alt="arrowIcon" />}
            />
            {error !== null && <Message message={error} type={'error'} />}
            {confirmMessage !== null && (
                <Message message={confirmMessage} type={'success'} />
            )}
            <div className="bg-white rounded-lg mt-5">
                <div className="flex flex-wrap p-[32px] gap-4 ">
                    <div className="flex  gap-4 w-full ">
                        <div className="flex-1">
                            <h2 className="text-[20px] font-semibold mb-[32px]">
                                Orden #{code}
                            </h2>
                            <div className="gap-2 flex  justify-between mb-[32px]">
                                <h2>Plantilla*</h2>
                                <div className="w-[65%]">
                                    <AppSelect
                                        options={templates}
                                        onChange={handleSelectTemplate}
                                        placeholder="Seleccionar uno"
                                        value={templateSelected}
                                    />
                                </div>
                            </div>
                            <div className="gap-2 justify-between  flex ">
                                <p>Descripción (opcional)</p>
                                <div className="w-[65%]">
                                    <TextArea
                                        placeholder="Escribe algunas líneas para describir a la orden"
                                        onChange={(value: string) =>
                                            setTextDescription(value)
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="border"></div>
                        <div className="flex-1 w-full max-w-[36%]">
                            <h2 className="text-[16px] font-semibold mb-4">
                                Previsualización
                            </h2>
                          {templateSelected == '' && <PreviewEmpty />}
                          {templateSelected !== '' && (
                                <div className="mt-4">
                                    <AccordionRules rules={rules} />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="flex justify-end border-t-2 pt-[32px] gap-[12px] w-full">
                        <AppButton
                            title="Descartar"
                            state="ghost"
                            onClick={() => navigate(-1)}
                        />
                        <AppButton
                            title="Cargar orden"
                            onClick={sendData}
                            disabled={templateSelected == ''}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
